export const eInvoiceStatuses = [
  {
    key: 'ready to submit',
    label: 'READY TO SUBMIT',
    color: 'primary',
  },
  {
    key: 'missing info',
    label: 'MISSING INFO',
    color: 'warning',
  },
  {
    key: 'valid',
    label: 'VALID',
    color: 'success',
  },
  {
    key: 'accepted',
    label: 'ACCEPTED',
    color: 'success',
  },
  {
    key: 'invalid',
    label: 'INVALID',
    color: 'danger',
  },
  {
    key: 'error',
    label: 'ERROR',
    color: 'danger',
  },
  {
    key: 'rejected',
    label: 'REJECTED',
    color: 'dark',
  },
  {
    key: 'cancelled',
    label: 'CANCELLED',
    color: 'dark',
  },
  {
    key: 'consolidated',
    label: 'CONSOLIDATED',
    color: 'dark',
  }
]
